import { FunctionalComponentWithChildren } from '../../../../../../FCWithChildren';
import StyledText, { TextSize, TextStyle } from '../../../../../shared/StyledText/StyledText';
import { FC } from 'react';

export interface ProductSKUProps {
    content?: string;
}

const ProductSKU: FunctionalComponentWithChildren<ProductSKUProps> = props => {
    return (
        <StyledText style={TextStyle.Body} size={TextSize.Small}>
            {props.content}
        </StyledText>
    );
};

export default ProductSKU;
